const map: any = {
"655360":"parse app_id or connection_id failed.",
"655361":"fetch app info failed.",
"655362":"fetch idp config.",
"655363":"authenticate user err.",
"655364":"authenticate user empty result.",
"655365":"authn token generation err.",
"655366":"authenticator not found.",
"655367":"err parse oauth code.",
"655368":"error parse connection config.",
"655369":"third-party login failed.",
"655370":"third-party result parsing failed.",
"655371":"incorrect username or password.",
"655372":"user not found or password does not match.",
"655373":"login method not allowed.",
"655374":"verification code does not match.",
"655375":"invalid token, decrypt token error.",
"655376":"invalid mfa challenge handler.",
"655377":"invalid mfa handler.",
"655378":"invalid credential.",
"655379":"invalid token, token not found.",
"655380":"invalid token, token expired.",
"655381":"invalid token, token invalid.",
"655382":"reset password token expired.",
"655383":"tenant policy check failed.",
"655384":"user locked because password failed too many times.",
"655385":"user creation failed.",
"655386":"save token to redis failed.",
"655387":"send mfa bind challenge failed, no user info, cannot get user info in current session.",
"655388":"send mfa bind challenge failed, mobile already bind.",
"655389":"send mfa bind challenge failed, mobile not bind.",
"655390":"send mfa bind challenge failed, email already bind.",
"655391":"send mfa bind challenge failed, email not bind.",
"655392":"send mfa challenge failed, no user info, cannot get user info in current session.",
"655393":"send mobile mfa challenge failed.",
"655394":"send email mfa challenge failed.",
"655395":"mfa bind failed, cannot get user info in current session.",
"655396":"mfa bind failed, invalid mobile or vercode.",
"655397":"mfa bind failed, get vercode failed.",
"655398":"mfa bind failed, del expired vercode failed.",
"655399":"mfa bind failed, vercode mismatch.",
"655400":"mfa bind failed, update user mobile failed.",
"655401":"mfa bind failed, invalid email or vercode.",
"655402":"mfa bind failed, update user email failed.",
"655403":"mfa failed, cannot get user info in current session.",
"655404":"mfa failed, verify code mismatch.",
"655405":"send reset password challenge failed.",
"655406":"reset password token invalid op.",
"655407":"reset password token ip changed.",
"655408":"reset password failed.",
"655409":"reset password failed, invalid code.",
"655410":"reset password failed, refresh token status failed.",
"655411":"reset password failed, operation not supported.",
"655412":"get user info failed from idp.",
"655413":"get user access token failed from idp.",
"655414":"get user openid failed from idp.",
"655415":"not enough user verification info.",
"655416":"mfa bind failed, OTP user already exists.",
"655417":"mfa bind failed, OTP creation failed.",
"655418":"send challenge failed, cannot get user info in current session.",
"655419":"mfa method not match.",
"655420":"not ram login.",
"655421":"trust login failed, decrypt token failed.",
"655433":"the system currently prohibits the user from logging in.",
"655434":"the verification code is required.",
"655435":"the verification code you entered is incorrect and cannot log in.",
"8193":"err sms provider.",
"8194":"send sms err.",
"8195":"sms param err.",
"8196":"does not comply with password policy rules.",
"8197":"err key gen.",
"8198":"err key gen - alg not supported.",
"8199":"update tenant failed, cannot retrieve orig tenant.",
"8200":"update tenant failed, invalid domain.",
"8201":"update schema failed, invalid orig schema.",
"8202":"cannot update current record.",
"8203":"the password is too simple.",
"8204":"cannot save this item.",
"8205":"cannot get dict item.",
"8206":"cannot get id connection item.",
"8207":"cannot get schema.",
"8208":"cannot get current tenant.",
"8209":"cannot delete tenant.",
"8210":"cannot save tenant.",
"8211":"tenant creation failed, duplicated tenant name.",
"8212":"cannot register developer without verification code.",
"8213":"cannot create dict item, empty category or key/value.",
"8214":"delete idp connection config failed.",
"8215":"cannot generate jwt token.",
"8216":"cannot generate kid.",
"8217":"cannot generate key.",
"8218":"cannot check jwt token.",
"8219":"cannot get jwt info.",
"8220":"jwt token expired.",
"8221":"verification failed.",
"8222":"cannot find token.",
"8223":"retrieve auth method config failed.",
"8224":"create auth method config failed.",
"8225":"save auth method config failed.",
"8226":"delete auth method config failed.",
"8227":"create auth method failed.",
"8228":"save/update auth method failed.",
"8229":"retrieve auth method failed.",
"8230":"create idp config failed.",
"8231":"save idp config failed.",
"8232":"retrieve idp config failed.",
"8233":"retrieve idp failed.",
"8234":"error send notification.",
"8235":"save tenant policy failed.",
"8236":"retrieve tenant policy failed.",
"8237":"password checking failed.",
"8238":"dev verification info already exists.",
"8239":"handle tenant creation failed.",
"8240":"save tenant log failed.",
"8241":"get tenant log failed.",
"8242":"get tenant secrets failed.",
"8243":"get tenant logo failed.",
"8244":"post tenant logo failed.",
"8245":"save dev update user failed.",
"8246":"send email failed.",
"8247":"dev verification real name failed.",
"8248":"user privilege error.",
"8249":"invalid user info or empty x-payload.",
"8250":"invalid args.",
"8251":"sign user info failed.",
"8252":"invalid auth method config id.",
"8253":"invalid auth method config request.",
"8254":"post dict item failed, invalid 'scope'.",
"8255":"err create tenant dict.",
"8256":"bad tenant dict request.",
"8257":"put tenant dict failed, invalid 'scope'.",
"8258":"get dict failed, empty 'key' and 'category'.",
"8259":"get dict failed, invalid 'category'.",
"8260":"save tenant policy failed, invalid 'id'.",
"8261":"get idp failed, invalid 'cid'.",
"8262":"get schema failed, invalid 'entityType'.",
"8263":"delete schema failed, invalid 'id'.",
"8264":"delete schema failed, invalid 'sid'.",
"8265":"get schema failed, invalid 'id'.",
"8266":"get tenant failed, invalid 'id'.",
"8267":"invalid idp config request.",
"8268":"put idp config failed, invalid 'id'.",
"8269":"bad tenant request.",
"8270":"delete tenant failed, invalid 'id'.",
"8271":"bad developer request.",
"8272":"delete idpc failed, invalid 'id'.",
"8273":"get developer failed, invalid 'id'.",
"8274":"get developer failed, invalid 'uid'.",
"8275":"get developer verification failed, invalid 'id'.",
"8276":"get developer verification failed, invalid 'devId', id in token mismatch id in path.",
"8277":"post dev token failed.",
"8278":"post dev token failed, invalid 'id'.",
"8279":"post dev token failed, invalid request.",
"8280":"common param error.",
"8281":"post kms failed, invalid request.",
"8282":"invalid key id.",
"8283":"get kms failed.",
"8284":"post dev user verification failed.",
"8285":"put schema failed, invalid 'id'.",
"8286":"put schema failed, invalid request.",
"8287":"save tenant failed, invalid 'id'.",
"8288":"delete amc failed, cannot retrieve origin amc.",
"8289":"delete amc failed, tenant violation.",
"8290":"delete idp failed, tenant violation.",
"8291":"get amc failed, tenant violation.",
"8292":"get idp failed, tenant violation.",
"8293":"get idpc failed, remove secret failed.",
"8294":"verify code failed, invalid type.",
"8295":"save schema failed.",
"8296":"save developer failed.",
"8297":"save developer verification failed.",
"8298":"save dict failed.",
"8299":"get dict failed, access denied.",
"8300":"delete tenant dict failed.",
"8301":"delete schema failed.",
"8302":"get developer failed.",
"8303":"get developer verification failed.",
"8304":"sms send failed, config error.",
"8305":"check tenant policy failed, unknown scene.",
"8306":"check password failed, parse request failed.",
"8307":"check password failed, tenant not found.",
"8308":"check password failed, password rule violation.",
"8309":"check password failed, password length violation.",
"8310":"check password failed, protection policy violation.",
"8311":"check password failed, password in blacklist.",
"8312":"check password failed, password in history.",
"8313":"modify developer password failed.",
"8314":"modify developer password failed, invalid request.",
"8315":"test ldap connection failed.",
"8316":"check identity failed.",
"8317":"update developer status failed.",
"8318":"post file failed.",
"8319":"get file failed.",
"8320":"create common dict failed.",
"8321":"update common dict failed.",
"8322":"delete common dict failed.",
"8323":"get dict failed, empty item.",
"8324":"save dev delegated user failed.",
"8325":"get dev delegated user failed.",
"8326":"delete dev delegated user failed.",
"8327":"send email failed, frequency limit.",
"8328":"get blacklist failed.",
"8329":"flush blacklist failed.",
"8330":"flush blacklist failed, too many items.",
"16842752":"generic error.",
"16842753":"authentication failed.",
"16842754":"app access denied.",
"16842755":"invalid mfa request.",
"16842756":"mfa failed, app not init.",
"16842757":"invalid auth request.",
"16842758":"invalid token or generate token failed.",
"16842759":"token expired.",
"16842760":"invalid token.",
"16842761":"refresh token failed.",
"16842762":"password reset failed.",
"16842763":"function exec failed (before auth).",
"16842764":"function exec failed (after auth).",
"16842765":"function exec failed (before signup).",
"16842766":"function exec failed (after signup).",
"16842767":"bad signup request.",
"16842768":"bad signup request, vercode mismatch.",
"16842769":"signup failed.",
"16842770":"init app failed, app not found.",
"16842771":"init tenant info failed.",
"16842772":"fetch proto config err: protocol not found.",
"16842773":"fetch proto config err: empty config.",
"16842774":"invalid app info during retrieve developer token.",
"16842775":"invalid id token during retrieve developer token.",
"16842776":"invalid developer token.",
"16842777":"invalid console domain",
"16842778":"user consent rejected",
"16842779":"user mobile already exists",
"16842780":"user email already exists",
"16842781":"function exec failed (before mfa).",
"16842782":"function exec failed (after mfa).",
"16842783":"get pub info failed.",
"16842784":"get user info failed.",
"16842785":"function exec failed (before mfa bind).",
"16842786":"user auto bind failed.",
"16842787":"create idp user failed.",
"16842788":"user manual bind failed.",
"16842789":"create native user failed.",
"16842790":"create idp transparent user failed.",
"16842791":"get advanced password policy v2 failed.",
"16842792":"make captcha failed.",
"16842793":"verify captcha failed.",
"16842794":"navigate to captcha failed.",
"131072":"username already exists.",
"131073":"mobile already exists.",
"131074":"email already exists.",
"131075":"ids length limit 1 to 1000.",
"131076":"empty original password .",
"131077":"empty new password .",
"131078":"invalid original password.",
"131079":"login name does not exist.",
"131080":"invalid user extended properties.",
"131081":"fetch tenant policy failed.",
"131082":"user social already exists.",
"131083":"user disabled.",
"131084":"invalid idp config id",
"720896":"",
"417793":"Flow execution timeout, terminate flow",
"417794":"Flow execution error, terminate flow",
"417795":"Function query error",
"417797":"Database update failure",
"417798":"Failed to call remote",
"421889":"",
"327732":"Node conflict",
"327733":"Remote service handshake failure",
"327734":"Remote service returns a failure",
"327735":"User not exists",
"327736":"Fetch snow ID failed",
"327737":"Duplicated key error",
"327744":"Create record failed",
"327745":"Update record failed",
"327746":"Query record failed",
"327747":"Delete record failed",
"327748":"Data incomplete error",
"327749":"Invalid data error",
"327750":"Root node exists",
"327751":"Destination node not exists",
"327752":"Delete Nonempty node error",
"327753":"Decode remote data error",
"327760":"Remote data bind error",
"327761":"object_code cannot be empty.",
"327762":"Invalid parameter: is_default.",
"327763":"Invalid path parameter: id.",
"327764":"sys_code cannot be empty.",
"327765":"code cannot be empty.",
"327766":"is_pointer cannot be empty.",
"327767":"name cannot be empty.",
"327768":"Invalid path parameter: user_id.",
"327769":"ids cannot be empty.",
"327776":"scene_code cannot be empty.",
"327779":"scope cannot be empty.",
"327780":"calc cannot be empty.",
"327781":"user_ids cannot be empty.",
"327782":"Incomplete relationship.",
"327783":"source_node_id and dest_node_id cannot be empty at the same time.",
"327784":"id and ids cannot be empty at the same time.",
"327785":"user_id cannot be empty.",
"327792":"node_id cannot be empty.",
"327793":"tree_code cannot be empty.",
"327794":"scene_code, tree_code, and node_id cannot be empty at the same time.",
"327795":"Invalid parameter: mode.",
"393217":"events cannot be empty",
"393218":"name cannot be empty",
"393219":"callback_url cannot be empty",
"393220":"req_format cannot be empty",
"393221":"req_format must be either json or form",
"393222":"req_param cannot be empty",
"393223":"id cannot be empty",
"393224":"flow_id cannot be empty",
"393225":"timeout is invalid",
"393232":"order_origin parameter is invalid",
"393233":"order_dest parameter is invalid",
"393234":"order_origin and order_dest should be of the same size",
"393235":"template_ids cannot be empty",
"393236":"stage cannot be empty",
"393237":"version cannot be empty",
"393238":"runtime cannot be empty",
"393239":"template cannot be empty",
"393240":"id, stage, version, and runtime cannot all be empty",
"393241":"ttl is invalid",
"393248":"ids cannot be empty",
"393249":"Cannot delete more than 1000 at once",
"393250":"Failed to retrieve snowId",
"393251":"Failed to create function",
"393252":"Failed to update function",
"393253":"Failed to query data",
"393254":"Triggered unique key constraint",
"393255":"Failed to delete function",
"393256":"Deleting non-empty resource",
"393257":"Exceeded limit of open Functions",
"393264":"Function is already open",
"393265":"Remote invocation failed",
"393266":"Failed to create flow",
"393267":"Failed to delete flow",
"393268":"Failed to update function template",
"393269":"Failed to create function template",
"393270":"Failed to delete program account",
"393272":"Failed to read user module stream",
"393273":"Failed to parse user module stream",
"393280":"Failed to create program account",
"393281":"Failed to update program account",
"524288":"application does not exist",
"524289":"incomplete application information",
"524290":"invalid redirect_uri",
"524291":"incomplete application configuration information",
"524292":"invalid application domain",
"524293":"sso server error",
"524294":"no application access",
"524295":"incomplete application sso protocol information",
"524296":"tenant does not exist",
"524297":"incomplete tenant information",
"524298":"invalid authorize request",
"524299":"enable implicit mode redirect must https",
"524300":"invalid code",
"524301":"invalid access token",
"524302":"invalid refresh_token",
"524303":"invalid application secret",
"524304":"user does not exist",
"524305":"account not opened",
"524306":"no account selected",
"12288":"duplicated app",
"12289":"duplicated app config",
"12290":"invalid app config id",
"12291":"duplicated app protocol",
"12292":"invalid app protocol id",
"12293":"duplicated app account",
"12294":"invalid app type",
"12295":"invalid app template id",
"12296":"invalid template value(s)",
"12297":"invalid app: name",
"12298":"invalid app: app id",
"12299":"invalid app: category",
"12300":"invalid app: domain",
"12301":"invalid app: redirect url",
"12302":"invalid app protocol: type",
"12303":"invalid app protocol: content",
"12304":"invalid too many app protocols",
"12305":"invalid app config: login method",
"12306":"invalid app config: default login method",
"12307":"invalid app config: register method",
"12308":"invalid app config: default register method",
"12309":"invalid app config: MFA config",
"12310":"invalid app config: idp id",
"12311":"invalid app config: default protocol",
"12312":"invalid app login url",
"12313":"invalid app logout url",
"12314":"multiple protocols were enabled",
"12315":"invalid app config: access policy",
"12316":"app has accounts",
"12317":"invalid user id",
"12318":"invalid account name",
"12319":"invalid account status",
"12320":"invalid username",
"12321":"invalid app prop key",
"12322":"invalid image",
"12323":"image too large",
"12324":"invalid user status",
"12325":"invalid tenant",
"12326":"invalid app sys ext",
"12327":"invalid app template name",
"12328":"invalid app template visible scope",
"12329":"app template status not match",
"12330":"app template has related apps",
"12331":"invalid image format",
"12332":"invalid app template type",
"12333":"invalid app template user param version",
"12334":"invalid account type",
"12335":"cannot change user",
"12336":"cannot set user id for shared account",
"12337":"invalid app account id",
"12338":"invalid expire at",
"12339":"expired app account",
"12340":"domain is too short",
"12341":"domain is too long",
"12342":"domain starts with reserved prefix",
"12343":"domain contains illegal words",
"12344":"domain conflicts with reserved domains"
};

export default map;
